// extracted by mini-css-extract-plugin
export default {"imageContainer":"app-image-viewer_imageContainer__Ry3Zi"};